import { FormSchema } from './form-schema';
import { SubdimensionsByName } from '@features/reports/subdomains/cpg';
import { sanitizeFormKey } from '@utils/form-keys';

export const defaultValues = (
  campaignName: string,
  subdimensionsByName: SubdimensionsByName
): FormSchema => ({
  campaignName,
  salesObjectives: [
    {
      value:
        'Drive incremental sales and traffic through a multi-channel media approach.',
    },
    {
      value:
        'Identify best media audiences to reach our ideal customer target.',
    },
  ],
  subdimensionImagesByNameAndValue: Object.entries(subdimensionsByName).reduce(
    (acc, [dimensionSlug, subdimensions]) => {
      acc[dimensionSlug] = subdimensions.reduce(
        (acc, subdimension) => {
          if (!acc) return acc;

          acc[sanitizeFormKey(subdimension.dimensionValue)] = null;
          return acc;
        },
        {} as FormSchema['subdimensionImagesByNameAndValue'][string]
      );
      return acc;
    },
    {} as FormSchema['subdimensionImagesByNameAndValue']
  ),
  includedSlides: {
    intro: {
      title: true,
      agenda: true,
      howWeDoIt: true,
    },
    sales: {
      cover: true,
      campaignSummaryGiroas: false,
      campaignOverview: true,
      campaignOverview2: true,
      who: true,
      what: true,
      where: true,
      how: true,
    },
  },
});
